import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import config from 'config'
import * as actions from 'modules/auth/actions'

import VideoLandingStep from './component'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    regenerateCode: actions.regenerateCode,
  }, dispatch),
})

export default compose(
  connect(undefined, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (localStorage.getItem('hyfy_state')) {
        this.props.actions.regenerateCode()
      } else {
        window.location.replace(config.HYFY_LOGIN_REDIRECT_URL)
      }
    },
  }),
)(VideoLandingStep)



// WEBPACK FOOTER //
// ./src/layouts/VideoLandingStep/index.js